import { FC } from 'react';

import { Option } from '@gn-audio/jss-core/common/models';

import { Filter } from 'api/jabraPublicApi';
import { JabraRadioButton, JabraRadioGroup } from 'common/components/JabraRadioGroup';

export interface RadioFilterProps {
  filter: Filter;
  selected?: Option;
  onSelect?: (option: Option) => void;
}

export const RadioFilter: FC<RadioFilterProps> = ({ filter, selected, onSelect }) => {
  const handleSelect = (value: string) => {
    const selectedOption = filter.options.find((opt) => opt.value == value);
    if (!selectedOption) return;
    onSelect && onSelect(selectedOption);
  };
  return (
    <JabraRadioGroup
      onValueChange={handleSelect}
      selected={selected?.value}
      title={filter.title}
      className="flex flex-wrap"
    >
      {filter.options.map(({ value, title, disabled }) => {
        return (
          <div key={value} className="basis-1/2">
            <JabraRadioButton disabled={disabled} value={value} title={title}></JabraRadioButton>
          </div>
        );
      })}
    </JabraRadioGroup>
  );
};
